const awardProgramCategories = ["Airline", "Bank", "Hotel", "Other"];

export { awardProgramCategories };
